import React from 'react';
import { Switch } from "react-router-dom";
import { AuthedRoutes } from '../components/AuthedRoutes'
import RiasecTest from '../pages/riasec/riasec-test'

export const riasecRoutes = () => {
  return (
    <Switch>
      <AuthedRoutes 
        menu='competency'
        exact 
        path={"/riasec"} 
        component={RiasecTest}
        showBreadcrumb={false}
        headerTitle="RIASEC Test"
        noPadding
      ></AuthedRoutes>
    </Switch>
  )
}